import { Component } from '@angular/core';

import { DialogPage } from '../../../../../lib/common/common.data';
import { UserBaseDlgComponent } from '../user-dlg-base.component';
import { USER_DLG_FUNC_REMOVE_CONTENT } from '../user-dlg-func.def';
import { UserInfo } from '../../user.data';

@Component({
    templateUrl: '../user-dlg-base.component.html',
    styleUrls: ['../../user.style.css'],
    standalone: false
})
export class UserRemoveDlgComponent extends UserBaseDlgComponent<UserInfo[], void> {
    ngOnInit(): void {
        this._action_txt = 'Delete';
        this._action_icon = 'fa-trash';
        this._content_func_name = USER_DLG_FUNC_REMOVE_CONTENT;

        this._isDataValid = true;
        this._page = DialogPage.action;

        super.ngOnInit();
    }

    submit(): void {
        this._errorMessage = null;
        this._page = DialogPage.submit;

        this.userSvc.removeUser(this.data).subscribe((res: { isFault: boolean, errorMessage?: string }) => {
            this._errorMessage = res.errorMessage;
            this._page = DialogPage.result;
        });
    }
}